import { z } from 'zod'
import { oc } from '@orpc/contract'

export const authorizationSign = oc
  .route({ method: 'POST', path: '/v2/authorization/sign' })
  .input(
    z.object({
      organizationId: z.string(),
      // ip / userAgent are NOT accepted from the client — they're part of the
      // signed audit trail and are derived server-side (see the handler),
      // mirroring consentSign.
      isRejected: z.boolean().optional(),
      patientHasReadConsent: z.boolean().optional(),
    }),
  )
  .output(z.object({ isSigned: z.boolean() }))
